<template>
  <div class="boy_warphry">
    <div class="rkcz">
      <div>居住地和户籍地不一致的人口</div>
      <div class="twos">
        <div class="one">
          <span>{{ rows.czwlrk }}</span><span>(人)</span>
          <div>居住地和户籍地不一致的总人口</div>
        </div>
        <!-- <div class="one aa">
          <span>31476</span><span>(人)</span>
          <div>男性人数</div>
        </div>
        <div class="one bb">
          <span>32434</span><span>(人)</span>
          <div>女性人口</div>
        </div> -->
      </div>
    </div>
    <!-- <el-card> -->
    <div class="npm">
      <p>人户分离人口离开登记地时间</p>
      <div ref="echartsINof" class="echarts" style="height: 55vh"></div>
    </div>
    <!-- </el-card> -->
  </div>
</template>

<script>
import { tj,czrk } from "@/network";
export default {
  data() {
    return {
      datas:[],
      name:"半年以上，不满一年",
      rows: {},
    };
  },
  created() {},
  mounted() {
    this.getInfoList();
    this.getname();
    this.getInfoData()
    // this.handEchart();
  },
  methods: {
    async getInfoList() {
      const { code, rows, total } = await czrk({villagesCode: "110105011"});
      this.rows = rows[0];
    },
    getname() {
      let myechart = this.$echarts.init(this.$refs.echartsINof);
      myechart.on("legendselectchanged", (params) => {
        // console.log(params.name);
        this.name = params.name;
        this.getInfoData();
      });
    },
    async getInfoData() {
      const { code, data, msg } = await tj({
        tableName: "jxq_jzdhhjdbyzdrk",
        streetCode: "110105011",
        isOutside:0
      });
      var compare = function (attribute) {
        return function (obj1, obj2) {
          var val1 = obj1[attribute];
          var val2 = obj2[attribute];
          // if (val1 < val2) {
          //   return 1;
          // } else if (val1 > val2) {
          //   return -1;
          // } else {
          //   return 0;
          // }
        };
      };
      if(this.name=="半年以上，不满一年"){
        let datas = data.sort(compare("ban")); //通过Id排序完成后的数组
      }else if(this.name=="一年以上，不满二年"){
        let datas = data.sort(compare("yi")); //通过Id排序完成后的数组
      }else if(this.name=="二年以上，不满三年"){
        let datas = data.sort(compare("er")); //通过Id排序完成后的数组
      }else if(this.name=="三年以上，不满四年"){
        let datas = data.sort(compare("san")); //通过Id排序完成后的数组
      }else if(this.name=="四年以上，不满五年"){
        let datas = data.sort(compare("si")); //通过Id排序完成后的数组
      }else if(this.name=="五年以上，不满十年"){
        let datas = data.sort(compare("wu")); //通过Id排序完成后的数组
      }else{
        let datas = data.sort(compare("shi")); //通过Id排序完成后的数组
      }
      // console.log(data)
      let czrk = [];
      let villages_name = [];
      let ban = [];
      let yi = [];
      let er = [];
      let san = [];
      let si = [];
      let wu = [];
      let shi = [];
      for (const item of data) {
        czrk.push(item.czrk);
        villages_name.push(item.villages_name);
        ban.push(item.ban);
        yi.push(item.yi);
        er.push(item.er);
        san.push(item.san);
        si.push(item.si);
        wu.push(item.wu);
        shi.push(item.shi);
      }
      this.handEchart(czrk,villages_name,ban,yi,er,san,si,wu,shi)
    },
    handEchart(e,es,ban,yi,er,san,si,wu,shi) {
      let myechart = this.$echarts.init(this.$refs.echartsINof);
      let option = {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "shadow",
          },
        },
         legend: {
          selectedMode: "single", //取消图例的点击事件
          textStyle:{
          color:"#fff",
        },
        },
        textStyle:{
          color:"#fff"
        },
        grid: {
          left: "3%",
          right: "4%",
          bottom: "3%",
          top:"30%",
          containLabel: true,
        },
        xAxis: [
          {
            type: "category",
            data: es,
            axisLabel: { interval: 0, rotate: 60 }
          },
          
        ],
        yAxis: [
          {
            type: "value",
            // data: ["半年以上，不满一年","一年以上，不满二年","二年以上，不满三年","三年以上，不满四年","四年以上，不满五年","五年以上，不满十年","十年以上"],
          },
        ],
        series: [
          {
            name: "半年以上，不满一年",
            type: "bar",
            stack: "Search Engine",
            // barWidth:'50%',
            emphasis: {
              focus: "series",
            },
            data: ban,
          },
          {
            name: "一年以上，不满二年",
            type: "bar",
            stack: "Ad",
            stack: "Search Engine",
            emphasis: {
              focus: "series",
            },
            data: yi,
          },
          {
            name: "二年以上，不满三年",
            type: "bar",
            stack: "Ad",
            stack: "Search Engine",
            emphasis: {
              focus: "series",
            },
            data: er,
          },
          {
            name: "三年以上，不满四年",
            type: "bar",
            stack: "Ad",
            stack: "Search Engine",
            emphasis: {
              focus: "series",
            },
            data: san,
          },
          {
            name: "四年以上，不满五年",
            type: "bar",
            stack: "Search Engine",
            data: si,
            emphasis: {
              focus: "series",
            },
            // markLine: {
            //   lineStyle: {
            //     type: "dashed",
            //   },
            //   data: [[{ type: "min" }, { type: "max" }]],
            // },
          },
          {
            name: "五年以上，不满十年",
            type: "bar",
            // barWidth: 5,
            stack: "Search Engine",
            emphasis: {
              focus: "series",
            },
            data: wu,
          },
          {
            name: "十年以上",
            type: "bar",
            stack: "Search Engine",
            emphasis: {
              focus: "series",
            },
            data: shi,
          },
          // {
          //   name: "十年以上",
          //   type: "bar",
          //   stack: "Search Engine",
          //   emphasis: {
          //     focus: "series",
          //   },
          //   data: [60, 72, 71, 74, 190, 130, 110],
          // },
          // {
          //   name: "Others",
          //   type: "bar",
          //   stack: "Search Engine",
          //   emphasis: {
          //     focus: "series",
          //   },
          //   data: [62, 82, 91, 84, 109, 110, 120],
          // },
          // {
          //   name: "Others",
          //   type: "bar",
          //   stack: "Search Engine",
          //   emphasis: {
          //     focus: "series",
          //   },
          //   data: [62, 82, 91, 84, 109, 110, 120],
          // },
        ],
      };
      myechart.setOption(option);
    },
  },
};
</script>

<style scoped lang="less">
.boy_warphry {
  background-color: rgba(20, 48, 99, 0);
  .npm {
    p {
      color: #fff;
      text-align: center;
      font-size: 18px;
      padding: 2vh;
    }
    .echarts {
      margin: 1vw;
    }
  }
}
.rkcz {
  div {
    color: #fff;
    text-align: center;
    margin-top: 2vh;
    font-size: 18px;
    margin-bottom: 2vh;
  }
  .twos {
    border: 1px solid #21517d;
    margin: 0 2vw;
    margin-bottom: 0.8vw;
    .one {
      display: inline-block;
      font-size: 18px;
      color: #fffd7d;
      padding-top: 1vh;
      span:nth-child(2) {
        font-size: 12px;
      }
      div {
        font-size: 12px;
        color: #fff;
        margin-top: 5px;
      }
    }
    .aa {
      border-top: 0;
      border-bottom: 0;
      padding: 0 2.5vw;
    }
  }
}
</style>
